import { BrowserRouter } from "react-router";

export const WithRouter = ({ children }: { children: React.ReactNode }) => (
    <BrowserRouter>
        {children}
    </BrowserRouter>
);